import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export type GetSettlementPdfParams = {
  oidLiquidacion: number;
};

export const getSettlementPdf = async ({
  oidLiquidacion,
}: GetSettlementPdfParams): Promise<string> => {
  try {
    const res = await apiClient.post<string>(Endpoints.ImpresionLiquidacion, {
      oidLiquidacion,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
